import { RouteView, PageView } from '../layouts'
export const sales = {
    path: '/sales',
    name: 'BaseForm',
    component: PageView,
    meta: { title: '销售管理', icon: 'dollar', isMenuShow: true ,permission:'sell'},
    children: [
        {
            path: '/sales/usercarlist',
            name: 'BaseForm',
            component: () => import('../views/sales/userCars.vue'),
            meta: { title: '用户车辆列表', keepAlive: false, isMenuShow: true ,permission:'sell:usercars'},
        },
        {
            path: '/sales/models',
            name: 'BaseForm',
            component: PageView,
            redirect: '/sales/modellibrary',
            meta: { title: '基础配置', icon: 'dollar', isMenuShow: true ,permission:'sell:modellibrary'},
            children: [
                {
                    path: '/sales/modellibrary',
                    name: 'BaseForm',
                    component: () => import('../views/sales/modelLibrary.vue'),
                    meta: { title: '车型库', keepAlive: false, isMenuShow: true ,permission:'sell:modellibrary:vehicle'},
                },
                // {
                // path: '/sales/modellibrary1',
                // name: 'BaseForm',
                // component: () => import('../views/sales/modelLibrary1.vue'),
                // meta: { title: '车型库', keepAlive: false, isMenuShow: true ,permission:'sell:modellibrary:vehiclesystem'},
                // },
                {
                    path: '/sales/modelsManagement',
                    name: 'BaseForm',
                    component: () => import('../views/sales/modelsManagement.vue'),
                    meta: { title: '车款管理', keepAlive: false, isMenuShow: true ,permission:'sell:modellibrary:vehicle' },
                },

            {
                path: '/sales/modelList',
                name: 'BaseForm',
                component: () => import('../views/sales/modelList.vue'),
                meta: { title: '车型列表', keepAlive: false, isMenuShow: true ,permission:'sell:modellibrary:vehicle'},
            },
            {
                path: '/sales/modellibrary/addModelManagment',
                name: 'BaseForm',
                component: () => import('../views/sales/addModelManagment.vue'),
                meta: { title: '新增车型', icon: 'dollar', isMenuShow: true ,permission:'sell:modellibrary:vehicle:add'},
            },
            {
                path: '/sales/modellibrary/addmodel',
                name: 'BaseForm',
                component: () => import('../views/sales/addModel.vue'),
                meta: { title: '新增车系', icon: 'dollar', isMenuShow: true ,permission:'sell:modellibrary:vehiclesystem:'},
            },
            {
                path: '/sales/modellibrary/newcar',
                name: 'BaseForm',
                component: () => import('../views/sales/newCar.vue'),
                meta: { title: '新增车型', icon: 'dollar', isMenuShow: true ,permission:'sell:modellibrary:vehicle:add'},
            },
            ]
        },
        {
            path: '/sales/recommendcar',
            name: 'BaseForm',
            component: () => import('../views/sales/recommendCar.vue'),
            meta: { title: '推荐购车', keepAlive: false, isMenuShow: true ,permission:'sell:recommendcar'},
        },
        {
            path: '/sales/buycar',
            name: 'BaseForm',
            component: () => import('../views/sales/buyCar.vue'),
            meta: { title: '我要购车', keepAlive: false, isMenuShow: true ,permission:'sell:buycar'},
        },
        {
            path: '/sales/saleslead',
            name: 'BaseForm',
            component: () => import('../views/sales/salesLead.vue'),
            meta: { title: '销售线索', keepAlive: false, isMenuShow: true ,permission:'sell:saleslead'},
        },
        {
            path: '/sales/orderlist',
            name: 'BaseForm',
            component: () => import('../views/sales/orderList.vue'),
            meta: { title: '工单列表', keepAlive: false, isMenuShow: true ,permission:'sell:orderlist'},
        },
        {
          path: '/sales/owners',
          name: 'BaseForm',
          component: PageView,
          redirect: '/sales/carTransfer',
          meta: { title: '车主手册', keepAlive: false, isMenuShow: true ,permission:'sell:orderlist'},
          children: [
            {
              path: '/sales/carTransfer',
              name: 'BaseForm',
              component: () => import('../views/sales/carTransfer.vue'),
              meta: { title: '车主手册', keepAlive: false, isMenuShow: true ,permission:'sell:orderlist'},
            },
            {
              path: '/sales/ownersMenu',
              name: 'BaseForm',
              component: () => import('../views/sales/ownersMenu.vue'),
              meta: { title: '车主手册', keepAlive: false, isMenuShow: true ,permission:'sell:orderlist'},
            },
            {
              path: '/sales/ownersVideo',
              name: 'BaseForm',
              component: () => import('../views/sales/ownersVideo.vue'),
              meta: { title: '车主手册', keepAlive: false, isMenuShow: true ,permission:'sell:orderlist'},
            },
            {
              path: '/sales/addMenu',
              name: 'BaseForm',
              component: () => import('../views/sales/addMenu.vue'),
              meta: { title: '添加手册', keepAlive: false, isMenuShow: true ,permission:'sell:orderlist'},
            },
            {
              path: '/sales/updateMenu',
              name: 'BaseForm',
              component: () => import('../views/sales/addMenu.vue'),
              meta: { title: '编辑手册', keepAlive: false, isMenuShow: true ,permission:'sell:orderlist'},
            },
            {
              path: '/sales/addVideo',
              name: 'BaseForm',
              component: () => import('../views/sales/addVideo.vue'),
              meta: { title: '添加视频', keepAlive: false, isMenuShow: true ,permission:'sell:orderlist'},
            },
            {
              path: '/sales/updateVideo',
              name: 'BaseForm',
              component: () => import('../views/sales/addVideo.vue'),
              meta: { title: '编辑视频', keepAlive: false, isMenuShow: true ,permission:'sell:orderlist'},
            },
          ]
        },
        {
          path: '/sales/driveClues',
          name: 'BaseForm',
          component: () => import('../views/sales/driveClues.vue'),
          meta: { title: '试驾线索', keepAlive: false, isMenuShow: true ,permission:'sell:saleslead'},
        }
    ]
}
